var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.form'] = (function () {
    'use strict';

    const initialize = (widget) => {
        const form = widget.querySelector("form");

        // update the file uploader button (should there be any) for conformance
        const uploaderButton = form.querySelector(".ktc-uploader-text-button");
        if (uploaderButton) {
            uploaderButton.setAttribute("href", "#");
            uploaderButton.addEventListener("click", function (e) { e.preventDefault(); });
        }

        // if the form has been modified for custom validation, send it that way
        if (form.hasAttribute("data-zag-validate-form")) {
            App.Initialization['component.formValidation'].initialize(form);
        }
    }

    return {
        initialize
    };

})();